import React, { useState, useEffect } from "react";
import {
  managementModalStyle,
  StyledModal,
} from "pages/PatientOverview/styles";
import {
  Box,
  TextField,
  Button,
  Typography,
  Grid,
  CircularProgress,
} from "@mui/material";
import { btnStyle } from "../styles";
import * as yup from "yup";

const EmailListModal = ({
  isOpen,
  setIsOpen,
  inviteFunction,
}: {
  isOpen: boolean;
  setIsOpen: any;
  inviteFunction: any;
}) => {
  const [emailList, setEmailList] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!isOpen) {
      window.localStorage.removeItem("emailBatch");
    }
  }, [isOpen]);
  const getData = () => {
    const processedDataRaw = window.localStorage.getItem("emailBatch") || "{}";
    const processedData = JSON.parse(processedDataRaw);
    return processedData;
  };
  const setData = (field: string, value: any) => {
    const processedDataRaw = window.localStorage.getItem("emailBatch") || "{}";
    const processedData = JSON.parse(processedDataRaw);
    window.localStorage.setItem(
      "emailBatch",
      JSON.stringify({
        ...processedData,
        [field]: value,
      })
    );
  };
  const handleSendBatch = async (e: any) => {
    window.localStorage.removeItem("emailBatch");
    const emailListRaw = emailList.replace(/ /g, "");
    const emailListArray = emailListRaw.split(",");
    setData("started", true);
    setData("isLoading", true);

    for (let i = 0; i < emailListArray.length; i++) {
      const patient = emailListArray[i];

      const emailSchema = yup.object().shape({
        email: yup.string().email().required(),
      });
      const isValidEmail = emailSchema.isValidSync({ email: patient });

      try {
        if (!isValidEmail) {
          throw new Error("Invalid email");
        }
        const response = await inviteFunction(
          { stopPropagation: () => {} },
          patient,
          true
        );
        if (response?.hasError) {
          throw new Error(response.errorMessage);
        }
        const processedData = getData();
        const newProcessed = [
          ...(processedData.processed || []),
          patient,
        ] as never[];
        setData("processed", newProcessed);
      } catch (error: any) {
        const processedData = getData();

        const newError = [
          ...(processedData.error || []),
          { patient, error: error?.message },
        ] as never[];

        setData("error", newError);
      }
    }
    setData("isLoading", false);

    setEmailList("");
  };

  const getErrorMessage = (errMessage: string) => {
    if (errMessage.includes("validation error detected")) {
      return "Email Validation error";
    }
    return errMessage;
  };

  return (
    <StyledModal
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
        window.localStorage.removeItem("emailBatch");
      }}
    >
      <Box sx={{ ...managementModalStyle, width: "95%" }}>
        <Grid container xs={12} sx={{ display: "flex" }}>
          <Grid item xs={5} style={{ marginRight: "10px" }}>
            <Typography variant="h5">Batch Email list invite</Typography>

            <Typography>Paste the emails separated by comma</Typography>

            <TextField
              fullWidth
              sx={{ mt: 4 }}
              error={Boolean(errorMessage)}
              label="Paste email list separated by comma"
              placeholder="Paste email list separated by comma, For example, john@gmail.com, sally@gmail.com"
              multiline
              onChange={(event) => {
                const value = event?.target.value;

                if (value.split(",")?.length > 50) {
                  return setErrorMessage(
                    `50 emails allowed per batch, current email count: ${
                      value.split(",")?.length
                    }`
                  );
                }
                setErrorMessage("");
                setEmailList(event?.target.value);
              }}
              rows={5}
            />
            <Typography
              variant="caption"
              sx={errorMessage ? { color: "red" } : {}}
            >
              {Boolean(errorMessage)
                ? errorMessage
                : " For example, john@gmail.com,sally@gmail.com,charles@gmail.com"}
            </Typography>

            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              <Button
                color="primary"
                onClick={handleSendBatch}
                disabled={getData().started || Boolean(errorMessage)}
                variant="contained"
                style={
                  !Boolean(errorMessage)
                    ? {
                        ...btnStyle,
                        marginBottom: "20px",
                        marginTop: "0px",
                        color: "white",
                      }
                    : {
                        marginBottom: "20px",
                        color: "white",
                        left: "0px",
                        top: "25px",
                      }
                }
              >
                {getData().isLoading ? (
                  <CircularProgress size={20} />
                ) : getData().started ? (
                  "All done"
                ) : (
                  "Send batch invite"
                )}
              </Button>
              <Button
                style={{ ...btnStyle, marginBottom: "20px", color: "white" }}
                onClick={() => {
                  setIsOpen(false);
                  window.localStorage.removeItem("emailBatch");
                }}
              >
                Close
              </Button>
            </div>
          </Grid>
          <Grid spacing={1} item xs={6} sx={{ marginLeft: "20px" }}>
            <Grid item xs={12} sx={{ mb: 2, marginTop: "90px" }}>
              {getData().started && (
                <Typography
                  sx={{ color: "green", borderBottom: "1px solid grey" }}
                >
                  <strong>
                    {" "}
                    Successfull invites: {getData().processed?.length}
                  </strong>
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sx={{ overflow: "scroll", height: "500px" }}>
              {getData().started && (
                <>
                  <Typography
                    sx={{ color: "red", borderBottom: "1px solid grey", mb: 1 }}
                  >
                    <strong> Failed invites: {getData().error?.length}</strong>
                  </Typography>
                  {!getData().isLoading && (
                    <>
                      {getData().error?.map((patient: any) => (
                        <div
                          style={{
                            display: "flex",
                          }}
                        >
                          <Typography sx={{ color: "red" }}>
                            {getErrorMessage(patient.error)}: &nbsp;{" "}
                          </Typography>
                          <Typography>
                            {" "}
                            <strong>{patient.patient}</strong>
                          </Typography>
                        </div>
                      ))}
                    </>
                  )}
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </StyledModal>
  );
};

export default EmailListModal;
